import $ from '@rover/globals/jquery';

import Alerts from './Alerts';

const flagFormSubmitSuccess = (response, status, xhr, $form) => {
  $form.closest('.js-feedback-modal').modal('hide');
  Alerts.showToast({
    severity: 'success',
    message: "Thank you for flagging this. We'll look at it as soon as possible",
  });
  $(window).scrollTop(0);
};

function init() {
  this.$flagForm = $('.js-flag-form');
  this.$flagForm.validate({
    rules: {
      comment: {
        required: true,
        minWords: 4,
      },
    },
  });
  this.$flagForm.autoDisableAndValidateAjaxForm({
    success: flagFormSubmitSuccess,
    resetForm: true,
  });

  if (window.location.hash === '#flag_dialog') {
    $('.js-flag-button').trigger('click');
  }
}

export default {
  init,
};



// WEBPACK FOOTER //
// ../utilities/flag-listing.js